import { IAppState } from '../../../AppModulesWrapper';

import { EFairPlayErrorCode } from '../../types/reducers/fairPlay';

export function selectFairPlayErrorCode(state: IAppState): EFairPlayErrorCode | null {
  const {
    fairPlay: { errorCode },
  } = state.servicePickerWidget;

  return errorCode;
}
